import React from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Marks a screen that is a preview rather than a feature: the table below it has no data source and never had one -
 * every column key is an empty string and the rows come from a hardcoded empty array.
 *
 * Renders above the table so the empty rows read as "not built yet" rather than "your data is gone".
 */
export const PlannedFeatureNotice = () => {
  const { t } = useTranslation();

  return (
    <Alert severity='info' variant='outlined' data-test-id='planned-feature-notice' sx={{ margin: '0.5rem 0' }}>
      {t('plannedFeature')}
    </Alert>
  );
};
